import { createClient } from '@sanity/client';

const projectId = process.env.REACT_APP_SANITY_PROJECT_ID;
const dataset = process.env.REACT_APP_SANITY_DATASET;
const apiVersion = process.env.REACT_APP_SANITY_API_VERSION || '2023-01-01';
const useCdn = process.env.NODE_ENV === 'production';
const readToken = process.env.REACT_APP_SANITY_READ_TOKEN;

const sanityClient =
  projectId && dataset
    ? createClient({ projectId, dataset, apiVersion, useCdn, readToken })
    : null;

if (!sanityClient) {
  console.warn(
    'Sanity client not initialized: missing project ID or dataset. Using mock data.'
  );
}

export { sanityClient };

export async function fetchSanity(query, params = {}) {
  if (!sanityClient) return null;
  try {
    return await sanityClient.fetch(query, params);
  } catch (err) {
    console.error('Sanity fetch failed', err);
    return null;
  }
}
